/**
 * Карточка Custom Software Development.
 */

import Typewriter from "../Typewriter/Typewriter";
import ServiceCard from "../ServiceCard/ServiceCard";
import SoftwareTerminal from "../SoftwareTerminal/SoftwareTerminal";
import { SERVICE_SOFTWARE } from "../../config/services";

function SoftwareCard() {
    const copy = SERVICE_SOFTWARE;

    return (
        <ServiceCard variant="software">
            <SoftwareTerminal />

            <div className="software-card-content">
                <h3 className="group-9__title group-9__title_software">
                    <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
                </h3>
                <p className="group-9__text group-9__text_software">
                    <Typewriter text={copy.text} speed={copy.textSpeed} delay={copy.textDelay} />
                </p>
            </div>
        </ServiceCard>
    );
}

export default SoftwareCard;
// components/ServiceCards/SoftwareCard.js
